import { defineStore } from 'pinia'

export const useToast = defineStore('toast', {
  state: () => ({
    dataToast: {
      open: false,
      title: '',
      message: '',
      icon: '',
      status: ''
    }
  }),
  actions: {
    closeToast() {
      this.dataToast.open = false
    }
  }
})